import React from "react";
import { IconRotate } from "@tabler/icons-react";
import SearchBar from "./SearchBar";
import FilterGroup from "./FilterGroup";
import { FILTER_TITLES } from "../utils/jobsConstants";

/**
 * Left sidebar: search box + "Filters" header with a reset link, followed by
 * the Location and Department filter groups.
 *
 * Props:
 * - search, onSearchChange
 * - locationOptions, selectedLocations, onToggleLocation
 * - departmentOptions, selectedDepartments, onToggleDepartment
 * - hasActiveFilters, onReset
 */
const Sidebar = ({
  search,
  onSearchChange,
  locationOptions,
  selectedLocations,
  onToggleLocation,
  departmentOptions,
  selectedDepartments,
  onToggleDepartment,
  hasActiveFilters,
  onReset,
}) => {
  return (
    <aside className="jobsSidebar">
      <SearchBar value={search} onChange={onSearchChange} />

      <div className="jobsFilters">
        <div className="jobsFiltersHeader">
          <p className="jobsFiltersTitle">Filters</p>
          {hasActiveFilters && (
            <button type="button" className="jobsResetLink" onClick={onReset}>
              <IconRotate size={16} stroke={2} />
              Reset filters
            </button>
          )}
        </div>

        <div className="jobsDivider" />

        <FilterGroup
          title={FILTER_TITLES.location}
          options={locationOptions}
          selected={selectedLocations}
          onToggle={onToggleLocation}
        />

        {departmentOptions.length > 0 && <div className="jobsDivider" />}

        <FilterGroup
          title={FILTER_TITLES.department}
          options={departmentOptions}
          selected={selectedDepartments}
          onToggle={onToggleDepartment}
        />
      </div>
    </aside>
  );
};

export default Sidebar;
